import {
    RequestService,
    RequestServiceResponse,
} from '@tcc-online/request-service';
import IInfo from '../../types/common/IInfo';

const ENDPOINT = '/config';

const InfoService = {
    getInfo,
};

async function getInfo(): Promise<RequestServiceResponse<IInfo>> {
    return await RequestService.get<IInfo>(
        `${ENDPOINT}`,
        {},
        { ignoreAuth: true },
    );
}

export default InfoService;
